import React, { useState, useCallback } from 'react';
import { useSizes } from '@/utility/responsive.ts';
import clsx from 'clsx';
import { INPUT_MAX_LENGTH } from '@/constants';
import { useMeeting } from '@/context/meeting-context';

interface MessageInputProps {
	onSendMessage: (message: string) => void;
	placeholder?: string;
	isSupport?: boolean;
}

const MAX_MESSAGE_LENGTH = INPUT_MAX_LENGTH.EXPERT_MESSAGE;

const MessageInput: React.FC<MessageInputProps> = ({ onSendMessage, placeholder = 'Mesajını buraya yazabilirsin...', isSupport = false }) => {
	const { isMobile } = useSizes();
	const { hasActiveMeeting, activeAppointment } = useMeeting();
	const [message, setMessage] = useState('');

	const handleSend = useCallback(() => {
		if (message.trim()) {
			onSendMessage(message);
			setMessage('');
		}
	}, [message, onSendMessage]);

	const handleKeyDown = useCallback(
		(e: React.KeyboardEvent<HTMLTextAreaElement>) => {
			if (e.key === 'Enter' && !e.shiftKey) {
				e.preventDefault();
				handleSend();
			}
		},
		[handleSend]
	);

	const handleMessageChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
		if (e?.target?.value?.length > MAX_MESSAGE_LENGTH) {
			return;
		}

		setMessage(e?.target?.value);
	}, []);

	return (
		<div className={clsx('chat-input', { 'support-chat-input': isSupport, 'active-meeting': hasActiveMeeting || activeAppointment })}>
			<textarea
				className="message-input"
				placeholder={placeholder}
				value={message}
				onChange={handleMessageChange}
				onKeyDown={handleKeyDown}
				maxLength={MAX_MESSAGE_LENGTH}
			/>
			<div className="chat-input-footer">
				<span className="char-count">
					{message?.length || 0}/{MAX_MESSAGE_LENGTH}
				</span>
				<button
					className="send-button"
					onClick={handleSend}
					disabled={!message.trim() || message?.length > MAX_MESSAGE_LENGTH}>
					{isMobile ? <i className="icons-plain" /> : 'Gönder'}
				</button>
			</div>
		</div>
	);
};

export default MessageInput;
